(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3789],{

/***/ 75774:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/truc-tiep/[id]",
      function () {
        return __webpack_require__(35752);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _features_livestream_detail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17499);



var LiveVideoDetailPage = function(param) {
    var liveVideo = param.liveVideo, isAuth = param.isAuth, collectionStickers = param.collectionStickers, comments = param.comments, offset = param.offset;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_livestream_detail__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        collectionStickers: collectionStickers.length > 0 ? collectionStickers : [],
        liveVideo: liveVideo,
        isAuth: isAuth,
        offset: offset,
        comments: comments
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (LiveVideoDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,2004,9077,1757,7499,9774,2888,179], function() { return __webpack_exec__(75774); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);